import { OrdemServicoFilters } from '@/types';

export const buildQueryParams = (filters?: OrdemServicoFilters, page: number = 1) => { 
  const params = new URLSearchParams();

  params.append('paginacao', 'true');
  params.append('pagina', page.toString());
  params.append('itens', '90000');
  params.append('campos[]', 'produto');
  params.append('campos[]', 'tipoChamado');
  params.append('campos[]', 'orcamento');
  params.append('filtro[status][]', 'aprovada');
  params.append('filtro[status][]', 'reprovada');
  params.append('filtro[status][]', 'aguardandoaprovacao');
  params.append('filtro[status][]', 'emrevisao');
  params.append('filtro[status][]', 'rascunho');
  params.append('filtro[status][]', 'cancelada');

  if (filters?.dataInicio) {
    params.append('filtro[periodo][]', filters.dataInicio);
  }
  if (filters?.dataFim) {
    params.append('filtro[periodo][]', filters.dataFim);
  }

  if (filters?.empresaCodigos && Array.isArray(filters.empresaCodigos) && filters.empresaCodigos.length > 0) {
    filters.empresaCodigos.forEach(codigo => {
      params.append('filtro[empresa][]', codigo.toString());
    });
  } else if (filters?.empresa) {
    if (!isNaN(Number(filters.empresa))) {
      params.append('filtro[empresa][]', filters.empresa);
    }
  }

  if (filters?.projeto) {
    params.append('filtro[projeto]', filters.projeto);
  }
  if (filters?.natureza) {
    params.append('filtro[natureza]', filters.natureza);
  }
  if (filters?.termo) {
    params.append('filtro[termo]', filters.termo);
  }

  return params.toString();
};
